module.exports = __webpack_public_path__ + "c0c13389e0c54cae7ffc4e8189a7c6ca.png";